// main.js - Allgemeine JavaScript-Funktionen für die Website

document.addEventListener('DOMContentLoaded', function() {
    // Hier können allgemeine Funktionen hinzugefügt werden, die auf mehreren Seiten verwendet werden.
    console.log('Die Website ist geladen und bereit.');
});

// Beispiel für eine Funktion, die auf mehreren Seiten verwendet werden kann
function toggleMenu() {
    const menu = document.getElementById('navbar');
    menu.classList.toggle('active');
}